define.alias("shared/components/shared/ui/switcher/action", "settings/components/shared/ui/switcher/action");